import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ROOMS, IMG, HOTEL } from "@/data/site";
import { ArrowUpRight } from "lucide-react";

export default function Rooms() {
  return (
    <>
      <Seo
        title="Rooms & Rates in Ottawa, KS"
        description="Explore rooms at Super 8 by Wyndham Ottawa, Kansas — King rooms, Double Queen rooms, Jacuzzi suites, Family rooms, Business rooms and accessible rooms. Most include a microwave, mini-fridge, coffee maker, HDTV and free WiFi."
        path="/rooms"
        image={IMG.doubleQueen}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Rooms", path: "/rooms" }]}
      />
      <PageHero
        kicker="Rooms & Suites"
        lines={["Pick your", "kind of", "comfort"]}
        sub="Six room styles for every kind of trip — all freshly kept, non-smoking, and stocked with the essentials. Most rooms include a microwave, mini-refrigerator, coffee maker, flat-screen HDTV and free WiFi."
        image={IMG.doubleQueen}
      />

      <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
        <div className="space-y-3">
          {ROOMS.map((r, i) => (
            <Reveal key={r.slug} i={i % 2}>
              <Link
                to={`/rooms/${r.slug}`}
                data-testid={`room-card-${r.slug}`}
                className="group grid overflow-hidden border-2 border-charcoal md:grid-cols-2"
              >
                <div className={`relative aspect-[16/10] overflow-hidden md:aspect-auto ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={r.image} alt={`${r.name} at ${HOTEL.name}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="flex flex-col justify-center gap-4 bg-bone p-8 transition-colors duration-300 group-hover:bg-brand-yellow md:p-14">
                  <span className="font-body text-xs font-semibold uppercase tracking-[0.3em] text-brand-red">{r.beds} · {r.sleeps}</span>
                  <h2 className="font-display text-4xl uppercase leading-none tracking-tight text-charcoal md:text-5xl">{r.name}</h2>
                  <p className="font-body text-base leading-relaxed text-fog group-hover:text-charcoal/80">{r.short}</p>
                  <span className="mt-2 inline-flex items-center gap-2 font-heading font-black uppercase text-charcoal">
                    View room <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <EditorialMarquee items={["Book Direct", "Best Rate", "Free Breakfast", "Free WiFi"]} />
    </>
  );
}
